export class CompanyModel {
  constructor(
    public id?:string,
    public companyName?: string,
    public address?: string,
    public city?: string,
    public postalCode?: string,
    public countryCode?: string,
    public countryId?: string,
    public taxNumber?: string,
    public email?: string,
    public phone?: string,
    public websiteUrl? :string,
    public generalManagerId?:string,
    public businessTypesCompanies?: BusinessType[],
    public isMembershipPaid?: boolean,
    public isTrialOver?: boolean,
    public isUsingTrial?: boolean,
    public isSubscribed?: boolean,
    public needCompanyUpdate?: boolean,
    public maxNumberOfVenues?: number,
    public minNumberOfVenues?: number,
    public allowedProcessors?: Array<any>,
  ) {}
}

export class BusinessType {
  constructor (
  public description?: string,
  public id?: number,
  public name?: string
  ) {}
}

export class CompanyRequest {
 
    public id?:null | string;
    public companyName?: null | string;
    public address?: null | string;
    public city?: null | string;
    public postalCode?: null | string;
    public countryCode?: null | string;
    public taxNumber?: null | string;
    public email?: null | string;
    public phone?: null | string;
    public websiteUrl? :null | string;
    public businessTypesCompanies?: BusinessType[]
  
}